import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Image from '../Image';

export const Pill = styled.div`
  display: flex;
  align-items: center;
  min-width: 142px;
  width: fit-content;
  border-radius: 3.25rem;
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};
  color: ${({ $textColor }) =>
    $textColor
      ? themeGet(`colors.${$textColor}`)
      : themeGet('colors.main-text')};
  padding: 0.25rem 1rem;
  justify-content: center;

  &.hero {
    margin-bottom: 1rem;
  }
`;

export const PillIcon = styled(Image)`
  height: 1rem;
  width: 1rem;
  margin-right: 0.5rem;
`;
